import { api } from '@/core/lib/api'
import { DEFAULT_PER_PAGE } from '@/core/lib/pagination'
import type { TResponse } from '@/core/types/axios'

import { auditEndpoints } from './audit.constants'
import type { TAuditFilters, TAuditLog } from './audit.types'

// Sunucu-taraflı sayfalama + filtre. actor → `filters=actor_email:<q>` (ilike substring),
// action → `filters=action:<v>` (eq), tarih → `created_from`/`created_to` (ISO, kapsayıcı).
// Zarfın tamamı (data + meta) döner. Salt-okuma — yazma ucu yok (append-only).
export async function getAuditListPaged(
  page: number,
  filters: TAuditFilters
): Promise<TResponse<TAuditLog[]>> {
  const params: Record<string, string | number> = {
    page,
    per_page: DEFAULT_PER_PAGE,
  }
  const filterParts: string[] = []
  if (filters.actor) filterParts.push(`actor_email:${filters.actor}`)
  if (filters.action) filterParts.push(`action:${filters.action}`)
  if (filterParts.length > 0) params.filters = filterParts.join(',')
  if (filters.from) params.created_from = filters.from
  if (filters.to) params.created_to = filters.to

  const res = await api.get<TResponse<TAuditLog[]>>(auditEndpoints.list, {
    params,
  })
  return res.data
}
